import React from 'react';
import TopNavbar from '../../../home/TopNavbar';

const styles = `
    .container {
        max-width: 1200px;
        margin: auto;
        background-color: #fff;
        padding: 10px;
        border-radius: 10px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        padding-bottom: 100px;
        margin-top: 30px;
    }

    /* Scrollable Table Wrapper */
    .table-wrapper {
        width: 100%;
        overflow-x: auto; /* Enables horizontal scrolling */
        -webkit-overflow-scrolling: touch; /* Smooth scrolling for iOS */
        margin-top: 20px;
        border-radius: 8px;
    }

    /* Heading styles */
    .main-heading {
        padding-top: 50px;
        color: #004d40;
        text-align: center;
        font-size: 1.5em;
        margin-bottom: 10px;
        border-bottom: 3px solid #004d40;
        padding-bottom: 10px;
    }

    .sub-heading {
        color: #00695c;
        font-size: 2em;
        margin-top: 40px;
        margin-bottom: 15px;
    }

    /* Paragraph styles */
    .intro-paragraph, .section-paragraph {
        font-size: 1em;
        text-align: justify;
        margin-bottom: 20px;
    }

    /* Table styles */
    table {
        width: 100%;
        min-width: 750px; /* Ensures table doesn't collapse on small screens */
        border-collapse: collapse;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    th, td {
        padding: 12px;
        text-align: left;
        border: 1px solid #ddd;
    }

    thead th {
        background-color: #004d40;
        color: #fff;
        font-weight: bold;
        text-transform: uppercase;
    }

    /* Alternating row colors */
    tbody tr:nth-child(even) {
        background-color: #e8f5e9;
    }

    tbody tr:nth-child(odd) {
        background-color: #f0fdf2;
    }

    /* Hover effect */
    tbody tr:hover {
        background-color: #c8e6c9;
        transition: background-color 0.3s ease;
    }

    /* Styling for the total row */
    tbody tr:last-child {
        font-weight: bold;
        background-color: #b2dfdb !important;
    }

    tbody tr:last-child td {
        border-top: 2px solid #004d40;
    }

    /* Custom Scrollbar styling */
    .table-wrapper::-webkit-scrollbar {
        height: 8px;
    }
    .table-wrapper::-webkit-scrollbar-thumb {
        background: #004d40;
        border-radius: 10px;
    }
    .table-wrapper::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
`;

const PhysicsData = [
    { chapter: "Alternating Current", easy: 4, medium: 8, hard: 1, total: 13, average: 2.60, weightage: '5.16%' },
    { chapter: "Atoms", easy: 3, medium: 4, hard: 0, total: 7, average: 1.40, weightage: '2.78%' },
    { chapter: "Center of Mass & System of Particles", easy: 1, medium: 4, hard: 0, total: 5, average: 1.00, weightage: '1.98%' },
    { chapter: "Current Electricity", easy: 6, medium: 19, hard: 0, total: 25, average: 5.00, weightage: '9.92%' },
    { chapter: "Dual Nature of Radiation and Matter", easy: 1, medium: 8, hard: 0, total: 9, average: 1.80, weightage: '3.57%' },
    { chapter: "Electric Charges and Fields", easy: 0, medium: 4, hard: 2, total: 6, average: 1.20, weightage: '2.38%' },
    { chapter: "Electromagnetic Waves", easy: 5, medium: 4, hard: 0, total: 9, average: 1.80, weightage: '3.57%' },
    { chapter: "Electrostatic Potential and Capacitance", easy: 7, medium: 8, hard: 2, total: 17, average: 3.40, weightage: '6.75%' },
    { chapter: "Gravitation", easy: 1, medium: 5, hard: 3, total: 9, average: 1.80, weightage: '3.57%' },
    { chapter: "Kinetic Theory", easy: 3, medium: 4, hard: 0, total: 7, average: 1.40, weightage: '2.78%' },
    { chapter: "Laws of Motion", easy: 2, medium: 3, hard: 0, total: 5, average: 1.00, weightage: '1.98%' },
    { chapter: "Magnetism and Matter", easy: 3, medium: 3, hard: 1, total: 7, average: 1.40, weightage: '2.78%' },
    { chapter: "Mechanical Properties of Fluids", easy: 2, medium: 4, hard: 1, total: 7, average: 1.40, weightage: '2.78%' },
    { chapter: "Mechanical Properties of Solids", easy: 3, medium: 1, hard: 1, total: 5, average: 1.00, weightage: '1.98%' },
    { chapter: "Motion in a Straight Line", easy: 0, medium: 8, hard: 0, total: 8, average: 1.60, weightage: '3.17%' },
    { chapter: "Moving Charges and Magnetism", easy: 2, medium: 8, hard: 1, total: 11, average: 2.20, weightage: '4.37%' },
    { chapter: "Nuclei", easy: 8, medium: 2, hard: 0, total: 10, average: 2.00, weightage: '3.97%' },
    { chapter: "Oscillations", easy: 2, medium: 3, hard: 2, total: 7, average: 1.40, weightage: '2.78%' },
    { chapter: "Ray Optics and Optical Instruments", easy: 4, medium: 6, hard: 4, total: 14, average: 2.80, weightage: '5.56%' },
    { chapter: "Rotational Motion", easy: 4, medium: 3, hard: 1, total: 8, average: 1.60, weightage: '3.17%' },
    { chapter: "Semiconductor Electronics", easy: 2, medium: 11, hard: 3, total: 16, average: 3.20, weightage: '6.35%' },
    { chapter: "Thermal Properties of Matter", easy: 0, medium: 2, hard: 0, total: 2, average: 0.40, weightage: '0.79%' },
    { chapter: "Thermodynamics", easy: 3, medium: 1, hard: 1, total: 5, average: 1.00, weightage: '1.98%' },
    { chapter: "Units and Measurements", easy: 6, medium: 7, hard: 1, total: 14, average: 2.80, weightage: '5.56%' },
    { chapter: "Wave Optics", easy: 2, medium: 2, hard: 2, total: 6, average: 1.20, weightage: '2.38%' },
    { chapter: "Waves", easy: 0, medium: 3, hard: 0, total: 3, average: 0.60, weightage: '1.19%' },
    { chapter: "Electromagnetic Induction", easy: 3, medium: 0, hard: 2, total: 5, average: 1.00, weightage: '1.98%' },
    { chapter: "Motion in a Plane", easy: 2, medium: 2, hard: 0, total: 4, average: 0.80, weightage: '1.59%' },
    { chapter: "Work Energy and Power", easy: 2, medium: 3, hard: 0, total: 5, average: 1.00, weightage: '1.98%' },
    { chapter: "Circular Motion", easy: 2, medium: 1, hard: 0, total: 3, average: 0.60, weightage: '1.19%' },
];

const renderTable = (data) => (
    <div className="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th>Chapter</th>
                    <th>Easy</th>
                    <th>Medium</th>
                    <th>Hard</th>
                    <th>Total</th>
                    <th>Average Q/yr</th>
                    <th>Weightage</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => (
                    <tr key={index}>
                        <td>{item.chapter}</td>
                        <td>{item.easy}</td>
                        <td>{item.medium}</td>
                        <td>{item.hard}</td>
                        <td>{item.total}</td>
                        <td>{item.average}</td>
                        <td>{item.weightage}</td>
                    </tr>
                ))}
                <tr>
                    <td><strong>Total</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.easy, 0)}</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.medium, 0)}</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.hard, 0)}</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.total, 0)}</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.average, 0).toFixed(2)}</strong></td>
                    <td><strong>100%</strong></td>
                </tr>
            </tbody>
        </table>
    </div>
);

const NeetWeightagePhysics = () => {
    return (
        <div>
            <style>{styles}</style>
            <div className="container">
                 <TopNavbar name="Physics Weightage" />
                <h1 className="main-heading">NEET 5-Year Physics Question Analysis (2020-2024)</h1>
                <p className="intro-paragraph">
                    A detailed analysis of the Physics section in NEET from 2020 to 2024 is presented, highlighting the distribution of questions by difficulty level and the average weightage per year. This aids students in strategizing their preparation effectively.
                </p>
                {renderTable(PhysicsData)}
            </div>
        </div>
    );
};

export default NeetWeightagePhysics;